import { render, staticRenderFns } from "./AromaProductDetail.vue?vue&type=template&id=1ef35c5c&scoped=true"
import script from "./AromaProductDetail.vue?vue&type=script&lang=js"
export * from "./AromaProductDetail.vue?vue&type=script&lang=js"
import style0 from "./AromaProductDetail.vue?vue&type=style&index=0&id=1ef35c5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef35c5c",
  null
  
)

export default component.exports